import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './components/login/login.component';
import { AdminDashboardComponent } from './admin/admin-dashboard/admin-dashboard.component';
import { FacultyDashboardComponent } from './faculty/faculty-dashboard/faculty-dashboard.component';
import { PlayerDashboardComponent } from './player/player-dashboard/player-dashboard.component';
import { authGuard } from './guards/auth.guard';
import { adminGuard } from './guards/admin.guard';
import { FinanceDecisionsComponent } from './player/finance-decisions/finance-decisions.component';
import { MktgDecisionsComponent } from './player/mktg-decisions/mktg-decisions.component';
import { EntryDecisionsComponent } from './player/entry-decisions/entry-decisions.component';
import { ProductionDecisionsComponent } from './player/production-decisions/production-decisions.component';
import { PeopleDecisionsComponent } from './player/people-decisions/people-decisions.component';
import {RanddDecisionsComponent} from './player/randd-decisions/randd-decisions.component';
import { ProductDecisionsComponent } from './player/product-decisions/product-decisions.component';
import { FacultyLandingScreenComponent } from './faculty/faculty-landing-screen/faculty-landing-screen.component';
import { GenerateReportComponent } from './faculty/generate-report/generate-report.component';

const routes: Routes = [
  { path: '', component: LoginComponent },
  { path: 'admin-dashboard', component: AdminDashboardComponent,  canActivate: [authGuard, adminGuard] },
  { path: 'faculty-dashboard', component: FacultyLandingScreenComponent, canActivate: [authGuard],
     children: [ { path: 'facultyDashboard', component: FacultyDashboardComponent },
      { path: 'generateReport', component: GenerateReportComponent },
                  { path: '', redirectTo: 'facultyDashboard', pathMatch: 'full' }
     ] },
  { path: 'player-dashboard', component: PlayerDashboardComponent , canActivate: [authGuard],
   children: [
      { path: 'entryDecisions', component: EntryDecisionsComponent },
      { path: 'financeDecisions', component: FinanceDecisionsComponent },
      { path: 'productDecisions', component: ProductDecisionsComponent },
      { path: 'RandDDecisions', component: RanddDecisionsComponent },
      { path: 'peopleDecisions', component: PeopleDecisionsComponent },
      { path: 'productionDecisions', component: ProductionDecisionsComponent },
      { path: 'marketingDecision', component: MktgDecisionsComponent },
      { path: '', redirectTo: 'finance', pathMatch: 'full' }
    ]},
  
  { path: '**', redirectTo: '', pathMatch: 'full' }      // Redirect unknown paths
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }




